import { combineReducers } from "redux";
import {createItemReducer, createItemReducerParams} from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function claimReducer() {
    return combineReducers({
        ClaimPersListForPO: createItemReducer("Claim", "ClaimPers.ListForPO", false),
        ClaimPersListForPOParams: createItemReducerParams("Claim", "ClaimPers.ListForPO"),
        ClaimPersSendClaimForPO: createItemReducer("Claim", "ClaimPers.SendClaimForPO", false),
        ClaimPersListForPO_Del: createItemReducer("Claim", "ClaimPers.ListForPO_Del", false),
        ClaimPersNewClaimForPO: createItemReducer("Claim", "ClaimPers.NewClaimForPO", false),
        ClaimPersNewClaimForPOParams: createItemReducerParams("Claim", "ClaimPers.NewClaimForPO"),
        ClaimPersGetClaimTempl: createItemReducer("Claim", "ClaimPers.GetClaimTempl", false),
        ClaimPersGetClaimData: createItemReducer("Claim", "ClaimPers.GetClaimData", false),
        ClaimPersSaveScan: createItemReducer("Claim", "ClaimPers.SaveScan", false),
        ClaimPersNewOneClaimForPO: createItemReducer("Claim", "ClaimPers.NewOneClaimForPO", false),
        ClaimPers_GetDefViewPO: createItemReducer("Claim", "ClaimPers.GetDefViewPO", false),
        ClaimPers_ListMisForPO: createItemReducer("Claim", "ClaimPers.ListMisForPO", false),
        ClaimPers_ListMisForPO_Params: createItemReducerParams("Claim", "ClaimPers.ListMisForPO"),
        ClaimPers_RollbackClaimPO: createItemReducer("Claim", "ClaimPers.RollbackClaimPO", false),
    });
}

